function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_b)"
}, /*#__PURE__*/React.createElement("rect", {
  y: 0.151566,
  width: 32,
  height: 24,
  rx: 4,
  fill: "url(#paint0_linear)",
  fillOpacity: 0.9
}));
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 8.15157,
  width: 12,
  height: 1,
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 8.15157,
  width: 12,
  height: 1,
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 20,
  y: 15.1516,
  width: 12,
  height: 1,
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  y: 15.1516,
  width: 12,
  height: 1,
  fill: "white"
});
var _ref7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_b",
  x: -20,
  y: -19.8484,
  width: 72,
  height: 64,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImage",
  stdDeviation: 10
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 0,
  y1: 0.151566,
  x2: 23.5,
  y2: 18.1516,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.834522,
  stopColor: "white",
  stopOpacity: 0.35
})));
function SvgChipCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 25,
    viewBox: "0 0 32 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipCard);
export default __webpack_public_path__ + "static/media/chip-card.e24b53b9f21b69cdaf709174c8f2d0cb.svg";
export { ForwardRef as ReactComponent };